import React from "react";
import PropTypes from "prop-types";
import { VictoryChart, VictoryAxis, VictoryBar, VictoryLegend, VictoryContainer } from "victory";
import { injectIntl, intlShape } from "react-intl";

import AlmigTheme, { almigOrange } from "../grundelemente/AlmigTheme";

import { getBarParams } from "./AnalyseTools";

import { genDailyMessage } from "./DailyValuesHelpers";
import { checkDailyProps } from "../model/util/DailyValues";
import { compressorTicksShort } from "../model/util/Components";

class Motorstarts extends React.Component {
	static propTypes = {
		model: PropTypes.object.isRequired,
		timespan: PropTypes.object.isRequired,
		rtc: PropTypes.string.isRequired,
		compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
		refresh: PropTypes.func.isRequired,
		intl: intlShape.isRequired
	};
	
	constructor(props, context) {
		super(props, context);
		checkDailyProps(props);
	}
	componentWillReceiveProps(nextProps) {
		checkDailyProps(nextProps);
	}
	render() {
		const { model, compressors, intl } = this.props;
		const pad_left = 40;
		const { bar_width, domain_padding } = getBarParams(model.data.length, pad_left, 1);

		return (
			<div>
				<VictoryChart theme={AlmigTheme}
					domainPadding={{ x: domain_padding }}
					padding={{ left: pad_left, top: 20, bottom: 20 }}
					containerComponent={<VictoryContainer className="printableAlmigItem"/>}>
					<VictoryLegend x={pad_left} y={0}
						data={[
							{ name: intl.formatMessage({id: "Motor starts"}), symbol: { fill: almigOrange }}
						]} />
					<VictoryAxis tickFormat={/* Achtung, hier tickFormat= verwenden, nicht
						tickValues= wie bei den Diagrammen mit VictoryGroup */
						compressorTicksShort(model.data, compressors, intl)} />
					<VictoryAxis dependentAxis />
					<VictoryBar data={model.data} x={d => d.cindex.toString()} y="motorstarts" color={almigOrange}
						style={{ data: { width: bar_width }}} />
				</VictoryChart>
				{genDailyMessage(model)}
			</div>
		);
	}
}

export default injectIntl(Motorstarts);
